import React from "react";
import "./BodySite.css"


const LoginSite = () => {
    
    return (
        <section>
       <div className="backgroundLogin" >
        <iframe className="loginContent" src="https://acceso.fire-bots.com/?idSite=abcde1234"></iframe>
       
        </div>
        </section>
    );
}

export default LoginSite;